export default __webpack_public_path__ + "static/media/PEGI_4.5df35453.svg";